import Lazyload from 'vanilla-lazyload';

import AbstractView from 'abstracts/AbstractView';



export default class Lazyloader extends AbstractView {
	
	constructor( $container, selector = '.img_lazy', options = {} ) {
		super();
		
		this.E = {
			FILE_LOADING:  'fileloading',
			FILE_LOADED:   'fileloaded',
			LOAD_COMPLETE: 'loadcomplete'
		};
		
		this.$container = $container;
		this.SELECTOR   = selector;
		this.lazyloader = null;
		this.options    = options;
		
		this._setOptions();
		
		if ( this.options.autoInit )
			this.init();
	}
	
	
	_setOptions() {
		this.options = Object.assign( {
			autoInit:     true,
			fileLoading:  false,
			fileLoaded:   false,
			loadComplete: false
		}, this.options );
	}
	
	
	initEl() {
		this._initLazyloader();
	}
	
	
	_initLazyloader() {
		this.lazyloader = new Lazyload( {
			container:         this.$container[0],
			elements_selector: this.SELECTOR,
			class_loaded:      'img_loaded',
			callback_loading:  this._onFileLoading.bind( this ),
			callback_loaded:   this._onFileLoaded.bind( this ),
			callback_finish:   this._onLoadComplete.bind( this )
		} );
	}
	
	
	_onFileLoading( $el ) {
		if ( this.options.fileLoading )
			this.emit( this.E.FILE_LOADING, $el );
	}
	
	
	_onFileLoaded( $el ) {
		$( $el ).parents( '.img_lazy_container' )[0].classList.add( 'img_loaded' );
		
		if ( this.options.fileLoaded )
			this.emit( this.E.FILE_LOADED, $el );
	}
	
	
	_onLoadComplete() {
		if ( this.options.loadComplete )
			this.emit( this.E.LOAD_COMPLETE );
	}
	
	
	bindEvents() {
		this.eh.forceLoadImages = this.update.bind( this );
		this.$container.on( 'forceLoadImages', this.eh.forceLoadImages );
	}
	
	
	unbindEvents() {
		this.$container.off( 'forceLoadImages', this.eh.forceLoadImages );
	}
	
	
	update() {
		if ( this.lazyloader )
			this.lazyloader.update();
	}
	
	
	loadAll() {
		if ( this.lazyloader )
			this.lazyloader.loadAll();
	}
	
	
	destroy() {
		super.destroy();
		
		this.lazyloader.destroy();
	}
	
};

